import React from "react"

import styles from "../styles/components/news-section.module.scss"

import Button from "./button"
import Carousel from "./carousel"

const NewsThumbnail = ({ source, description, link }) => {
  return (
    <div className={styles.newsThumbnail}>
      <h3 className={styles.label}>{source}</h3>
      <p className={styles.paragraph}>{description}</p>
      <div className={styles.buttonWrapper}>
        <Button short whiteGreen text="View the Post" externalLink={link} />
      </div>
    </div>
  )
}

class NewsSection extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>{this.props.title}</h2>
        <Carousel
          items={
            this.props.news &&
            this.props.news.map((newsItem, i) => (
              <NewsThumbnail
                key={i}
                source={newsItem.source}
                description={newsItem.description}
                link={newsItem.link}
              />
            ))
          }
        />
      </div>
    )
  }
}

export default NewsSection
